import React from "react";

function Team(){
    const teamMembers = [
        {
            name: "Dr Pramod Nair",
            title: "Principal Investigator",
            description: "Dr Nair is a Group Leader of the Computational and Molecular Pharmacology Laboratory at the College of Medicine and Public Health, Flinders University. His research focuses on drug discovery for neuropsychiatric disorders and cancer. His research integrates computational medicinal chemistry, pharmacogenomics, and experimental pharmacology to drive advancements in precision medicine. Through innovative collaboration, his team advances the translation of personalised treatment strategies from bench to bedside, driving progress in personalised medicine and shaping the future of targeted therapeutics.",
            role: "",
            image: "",
            website: "https://www.nair-lab.com/"
        },


        {
            name: "Dr Shashikanth Marri",
            title: "Bioinformatician",
            description: "Dr. Shashikanth earned his PhD in Genetics from Osmania University, India, in 2008, focusing on computational mapping of splicing factors in the rice genome. He has worked on the Palm Oil Genome project at Sime Darby, conducted bioinformatics research at ANU, and currently leads bioinformatics research and services at Flinders University.",
            role: "",
            image: "/team/shashikanth-marri.jpg"
        },
        {
            name: "Britto Shajan",
            title: "PhD Student",
            description: "Britto Shajan is a PhD candidate at Flinders University researching the pharmacology and functional biology of Trace Amine-Associated Receptor 1 (TAAR1). His work explores TAAR1's structure-function relationships and signalling mechanisms to understand its role in neuropsychiatric disorders and its potential as a therapeutic target.",
            role: "",
            image: "/team/britto-shajan.jpg"
        },

        {
            name: "Soyal James",
            title: "Research Student, Molecular Biology",
            description: "Soyal James is a second-year research student passionate about molecular biology and its role in understanding health and disease. He has gained practical experience in computational chemistry research at Flinders University, integrating molecular and computational approaches to explore biological mechanisms and potential therapeutic insights.",
            role: "",
            image: "https://media.licdn.com/dms/image/v2/D5603AQF6sp_fV1pZoQ/profile-displayphoto-scale_200_200/B56ZeaD7afHUAY-/0/1750636411083?e=1762992000&v=beta&t=i060F14k5deJmApbReOauvFvN91Hx6ue_SkNie0vLy8"
        },
        {
            name: "Bevan Shajan",
            title: "Developer",
            description: "Bevan Shajan is the developer of MiNTdb, responsible for the design, implementation, and optimisation of the platform. With a background in robotics and electrical engineering, he combines software development expertise in Python, web technologies, and automation to create an efficient and user-friendly database for bioinformatics research.",
            role: "",
            image: "https://media.licdn.com/dms/image/v2/D5603AQFSUFSIreeZKQ/profile-displayphoto-scale_200_200/B56ZjzTxfBHQAY-/0/1756428706244?e=1762992000&v=beta&t=bHMQgRJrU3s0DR8DeX-b2RmcK95R3-IsgtS5IL8jPag"
        }
    ];

    const collaborators = [
        {
            name: "Professor Julio Licinio",
            institution: "State University of New York Upstate Medical University"
        },
        {
            name: "Professor Lyle Palmer",
            institution: "Adelaide University"
        },
        {
            name: "Professor Tarun Bastiampillai",
            institution: "Monash University"
        },
        {
            name: "Professor Sherry Kit Wa Chan",
            institution: "University of Hong Kong"
        },
        {
            name: "A/Professor Grazia Rutigliano",
            institution: "University of Pisa"
        },
        {
            name: "Ashutosh Mishra",
            institution: "IIT Kharagpur"
        }
    ];

    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: '#FBFBFC',
            paddingBottom: '3rem'
        }}>
            <div className="container">
                {/* Header Section */}
                <div className="row justify-content-center text-center" style={{paddingTop: '4rem', paddingBottom: '2rem'}}>
                    <div className="col-lg-8">

                        <h1 style={{
                            fontSize: '3rem',
                            fontWeight: '700',
                            color: '#1A2940',
                            marginBottom: '1rem'
                        }}>
                            Meet Our Team
                        </h1>
                        <p style={{
                            fontSize: '1rem',
                            color: '#64748b',
                            lineHeight: '1.6',
                            maxWidth: '600px',
                            margin: '0 auto'
                        }}>
                            The dedicated team of researchers, developers, and scientists who built and maintain
                            the MintDB neuropsychiatric mutation database.
                        </p>
                    </div>
                </div>

                <hr style={{
                    borderColor: '#eef2f6',
                    margin: '2rem 0'
                }}></hr>

                {/* Team Members List */}
                <div className="row justify-content-center">
                    <div className="col-12">
                        <h4 style={{
                            color: '#1A2940',
                            fontWeight: 'bold',
                            marginBottom: '2rem',
                            textAlign: 'center'
                        }}>
                            The Team
                        </h4>
                    
                    <div style={{padding: '0'}}>
                        {teamMembers.map((member, index) => (
                            <div
                                key={index}
                                style={{
                                    backgroundColor: 'white',
                                    border: '1px solid #eef2f6',
                                    borderRadius: '12px',
                                    padding: '2rem',
                                    marginBottom: '1.5rem',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)';
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                }}
                            >
                                <div className="row align-items-center">
                                    <div className="col-12">
                                        <h5 style={{
                                            color: '#1A2940',
                                            fontWeight: 'bold',
                                            margin: '0 0 0.5rem 0',
                                            fontSize: '1.4rem'
                                        }}>
                                            {member.name}
                                        </h5>
                                        <p style={{
                                            color: '#60a5fa',
                                            fontSize: '0.95rem',
                                            fontWeight: '600',
                                            margin: '0 0 1rem 0'
                                        }}>
                                            {member.title}
                                        </p>
                                        <p style={{
                                            color: '#64748b',
                                            fontSize: '0.95rem',
                                            lineHeight: '1.6',
                                            margin: '0'
                                        }}>
                                            {member.description}
                                        </p>
                                        {member.website ? (
                                            <a
                                                href={member.website}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: '#60a5fa',
                                                    fontSize: '0.9rem',
                                                    fontWeight: '600',
                                                    display: 'inline-block',
                                                    marginTop: '0.75rem'
                                                }}
                                            >
                                                Lab Website →
                                            </a>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <hr style={{
                        borderColor: '#eef2f6',
                        margin: '2rem 0'
                    }}></hr>

                    <h4 style={{
                        color: '#1A2940',
                        fontWeight: 'bold',
                        marginBottom: '1rem',
                        textAlign: 'center'
                    }}>
                        Collaborators
                    </h4>

                    <div style={{maxWidth: '600px'}}>
                        {collaborators.map((collab, index) => (
                            <div key={index} style={{
                                display: 'flex',
                                alignItems: 'baseline',
                                padding: '0.5rem 0',
                                borderBottom: index < collaborators.length - 1 ? '1px solid #eef2f6' : 'none'
                            }}>
                                <span style={{
                                    color: '#1A2940',
                                    fontWeight: '600',
                                    fontSize: '0.95rem',
                                    marginRight: '0.5rem',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {collab.name}
                                </span>
                                <span style={{
                                    color: '#94a3b8',
                                    fontSize: '0.85rem'
                                }}>
                                    — {collab.institution}
                                </span>
                            </div>
                        ))}
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Team;